import crossFetch from 'cross-fetch';
export var resolveFetch = function resolveFetch(customFetch) {
  var _fetch;

  if (customFetch) {
    _fetch = customFetch;
  } else if (typeof fetch === 'undefined') {
    _fetch = crossFetch;
  } else {
    _fetch = fetch;
  }

  return function () {
    return _fetch.apply(void 0, arguments);
  };
};